import React, { useState, useRef, useEffect } from "react";
import {
  Col,
  ColType,
  Crud,
  CrudApi,
  CrudAction,
  CrudOption,
} from "../../comp/crud";
import {
  ApiClient,
  getLoanStatusOpt,
  displayLoanStatus,
  getLoanAuditingStatusOpt,
  displayLoanAuditingStatus,
  Lead,
  LoanAuditingStatus,
  displayLeadStatus,
  getLeadStatusOpt,
} from "../../api/ApiClient";
import { LoanDetail } from "./loanDetail";
import { formatAmountZhCn, displayStar, formatRelativeTime } from "../../utils";
import {
  Button,
  Form,
  Modal,
  Toast,
  Typography,
  Tooltip,
  Select,
} from "@douyinfe/semi-ui";
import { FormApi } from "@douyinfe/semi-ui/lib/es/form";
import { TextCell, TextCellLoanRemark } from "../../comp/cell";
import pubsub from "pubsub-js";
import { useLocation } from "react-router-dom";
import { IconModalStroked } from "@douyinfe/semi-icons";

export type LoanType =
  | "all"
  | "new"
  | "payout"
  | "paid"
  | "my"
  | "notAssign"
  | "team";

export interface LoanCrudProps {
  type: LoanType;
  name: string;
  router: string;
}
const apiClient = ApiClient.getDefault();

export function LoanCrud(props: LoanCrudProps) {
  const [crudApi, setCrudApi] = useState(undefined as undefined | CrudApi);
  const [loan, setLoan] = useState(undefined as undefined | Lead);
  const [leadIds, setLeadIds] = useState([] as number[]);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [selectedLoans, setselectedLoans] = useState([] as any[]);
  const selectedLoansRef = useRef(selectedLoans);
  selectedLoansRef.current = selectedLoans;
  const [assignSaving, setAssignSaving] = useState(false);
  const [assignFormApi, setAssignFormApi] = useState(
    undefined as undefined | FormApi
  );
  const [showAssignSaleModal, setShowAssignSaleModal] = useState(false);
  const [selectedLeads, setSelectedLeads] = useState([] as any[]);
  const [selectedMembers, setSelectedMembers] = useState([] as any[]);
  const selectedMembersRef = useRef(selectedMembers);
  const [assignSaleFormApi, setAssignSaleFormApi] = useState(
    undefined as undefined | FormApi
  );
  const [teamMembersTree, setTeamMembersTree] = useState([] as any[]);
  const [selectedAgents, setSelectedAgents] = useState([] as any[]);

  const username = localStorage.getItem("username");
  const userRealName = localStorage.getItem("userRealName");
  const activiRoute = useLocation().pathname.replace("/", "");
  const role = localStorage.getItem("role");
  const [isAdd, setIsAdd] = useState(false);

  const getIsInPoolOpts = async (): Promise<CrudOption[]> => {
    const statusOpts: any = [
      {
        label: "非公海",
        value: 0,
        key: 1,
      },
      {
        label: "公海",
        value: 1,
        key: 0,
      },
    ];
    return statusOpts;
  };

  let cols: Col[] = [
    {
      name: "客户ID",
      key: "id",
      width: 80,
      hideInCreate: true,
      showInFilter: true,
      type: ColType.STRING,
    },

    {
      name: "客户姓名",
      key: "name",
      width: 80,
      hideInCreate: true,
      showInFilter: true,
      type: ColType.STRING,
      render: (value, record, index) => {
        return (
          <Button
            theme="borderless"
            type="primary"
            onClick={() => detailAction(record, crudApi?.getData())}
          >
            {value}
          </Button>
        );
      },
    },
    {
      name: "上门时间",
      key: "actVisitTimeNew",
      width: 150,
      hideInCreate: true,
      showInFilter: true,
      type: ColType.DATE_RANGE,
      defaultSortOrder: ["all", "my", "notAssign"].includes(props.type)
        ? "descend"
        : false,
    },
    // {
    //   name: "签单时间",
    //   key: "signedContractAt",
    //   hideInCreate: true,
    //   showInFilter: true,
    //   type: ColType.DATE_RANGE,
    //   defaultSortOrder: false,
    // },
    // {
    //   name: "状态",
    //   key: "status",
    //   colSort: 3,
    //   showInFilter: false,
    //   colFilterSort: 3,
    //   hideInCreate: true,
    //   render: (value, index) => {
    //     if (value == "PENDING_CONTACT") {
    //       return (
    //         <Typography.Text type="danger">
    //           {displayLeadStatus(value)}
    //         </Typography.Text>
    //       );
    //     } else {
    //       return <Typography.Text>{displayLeadStatus(value)}</Typography.Text>;
    //     }
    //   },
    //   getOptions: () => Promise.resolve(getLeadStatusOpt()),
    //   type: ColType.SELECT,
    // },
    {
      name: "销售",
      key: "saleName",
      width: 80,
      hideInCreate: true,
      type: ColType.STRING,
    },
    {
      name: "销售",
      key: "saleId",
      hideInCreate: true,
      hideInList: true,
      showInFilter: true,
      type: ColType.SELECT,
      getOptions: () => apiClient.getSalesAsOpts(),
    },
    {
      name: "按揭专员",
      key: "agentId",
      width: 80,
      hideInCreate: true,
      hideInList: true,
      showInFilter: true,
      type: ColType.SELECT,
      getOptions: () => apiClient.getTeamAgentsAsOpts("agent"),
    },
    {
      name: "团队",
      key: "saleTeamId",
      hideInCreate: true,
      showInFilter: true,
      hideInList: true,
      type: ColType.TREE,
      getOptions: () => apiClient.getTeamAsOpts(),
    },

    {
      name: "销售部门",
      key: "saleTeamName",
      hideInCreate: true,
      showInFilter: false,
      hideInList: true,
      type: ColType.STRING,
    },
    {
      name: "是否在公海",
      key: "isInPool",
      hideInCreate: true,
      showInFilter: true,
      hideInList: true,
      type: ColType.SELECT,
      getOptions: () => getIsInPoolOpts(),
    },

    {
      name: "金额",
      key: "applyAmount",
      width: 80,
      hideInCreate: true,
      showInFilter: false,
      type: ColType.NUMBER,
      render: (a) => formatAmountZhCn(a),
    },
    {
      name: "城市",
      key: "applyCity",
      width: 50,
      hideInCreate: true,
      showInFilter: true,
      type: ColType.SELECT,
      getOptions: () => apiClient.getDictAsOpts("city"),
    },
    {
      name: "星级",
      key: "star",
      width: 50,
      hideInCreate: true,
      showInFilter: true,
      render: (a) => displayStar(a),
      getOptions: () =>
        Promise.resolve([
          { label: "0星", value: "0", key: "0" },
          { label: "1星", value: "1", key: "1" },
          { label: "2星", value: "2", key: "2" },
          { label: "3星", value: "3", key: "3" },
          { label: "4星", value: "4", key: "4" },
          { label: "5星", value: "5", key: "5" },
        ]),
      type: ColType.SELECT,
    },
    {
      name: "资质",
      key: "remark",
      width: 210,
      hideInCreate: true,
      showInFilter: true,
      render: (a, b, c) => <TextCell text={a} width={200} />,
      type: ColType.STRING,
    },

    // {
    //   name: "预计回款",
    //   key: "estPayAmount",
    //   hideInCreate: true,
    //   type: ColType.NUMBER,
    // },
    // {
    //   name: "预计创收",
    //   key: "estProfit",
    //   hideInCreate: true,
    //   type: ColType.NUMBER,
    // },

    // {
    //     name: "批复时间",
    //     key: "passedAt",
    //     hideInCreate: true,
    //     showInFilter: true,
    //     type: ColType.DATE_RANGE
    // },
    // {
    //     name: "批复额度",
    //     key: "passedAmount",
    //     hideInCreate: true,
    //     type: ColType.NUMBER
    // },
    // {
    //     name: "放款时间",
    //     key: "payoutAt",
    //     hideInCreate: true,
    //     type: ColType.DATE_RANGE,
    //     showInFilter: true
    // },
    // {
    //   name: "放款额度",
    //   key: "payoutAmount",
    //   hideInCreate: true,
    //   type: ColType.NUMBER,
    //   render: (a) => formatAmountZhCn(a),

    // },
    // {
    //   name: "回款时间",
    //   key: "paidAt",
    //   hideInCreate: true,
    //   type: ColType.DATE_RANGE,
    //   showInFilter: true,
    // },
    // {
    //   name: "回款额度",
    //   key: "paidAmount",
    //   hideInCreate: true,
    //   type: ColType.NUMBER,
    //   render: (a) => formatAmountZhCn(a),
    // },
    // {
    //   name: "实际创收",
    //   key: "profit",
    //   hideInCreate: true,
    //   type: ColType.NUMBER,
    //   render: (a) => formatAmountZhCn(a),
    // },
    // {
    //     name: "预计批复时间",
    //     key: "estPassedTime",
    //     hideInList: true,
    //     type: ColType.DATETIME
    // },
    // {
    //     name: "预计回款",
    //     key: "estPayAmount",
    //     hideInList: true,
    //     type: ColType.NUMBER
    // },
    // {
    //     name: "预计成本",
    //     key: "estCost",
    //     hideInList: true,
    //     type: ColType.NUMBER
    // },
    // {
    //   name: "定金",
    //   key: "deposit",
    //   hideInList: true,
    //   type: ColType.NUMBER,
    // },

    {
      name: "确认状态",
      key: "auditingStatus",
      hideInCreate: true,
      type: ColType.SELECT,
      showInFilter: false,
      hideInList: true,
      render: (a) => displayLoanAuditingStatus(a),
      getOptions: () => Promise.resolve(getLoanAuditingStatusOpt()),
    },
  ];

  let assignedCol: Col[] = [
    {
      name: "按揭专员",
      key: "agentName",
      width: 80,
      hideInCreate: true,
      type: ColType.STRING,
    },
    {
      name: "按揭记录",
      key: "todoLogs",
      colSort: 8,
      hideInEdit: true,
      width: 210,
      hideInCreate: true,
      render: (value, index) => (
        <TextCellLoanRemark moreText={value ? value : []} width={200} />
      ),
      type: ColType.STRING,
    },
    {
      name: "上次联系时间",
      key: "lastTodoAt",
      width: 150,
      colSort: 9,
      hideInCreate: true,
      showInFilter: false,
      defaultSortOrder: false,
      type: ColType.DATE_RANGE,
      render: (a: any) => <TextCell text={formatRelativeTime(a)} width={150} />,
    },
    {
      name: "添加时间",
      key: "agentAt",
      width: 150,
      colSort: 9,
      hideInCreate: true,
      showInFilter: false,
      defaultSortOrder: ["team"].includes(props.type) ? "descend" : false,
      type: ColType.DATE_RANGE,
      render: (a: any) => <TextCell text={formatRelativeTime(a)} width={150} />,
    },
  ];

  let refreshLeadInterval: any = useRef();
  useEffect(() => {
    localStorage.setItem(props.type + "-loan-refresh", "false");

    apiClient
      .getTeamMemberTreeAsOptsOfAny("root")
      .then((opts) => setTeamMembersTree(opts));

    apiClient.getTeamAgentsAsOpts("agent").then((opts) => setSelectedAgents(opts));

    return () => {
      console.log("离开页面------------");
      // 清除定时器
      clearInterval(refreshLeadInterval.current);
    };
  }, []);

  useEffect(() => {
    selectedMembersRef.current = selectedMembers;
  }, [selectedMembers]);

  //tab到当前页面刷新列表
  if (activiRoute == props.router) {
    let refreshMark = localStorage.getItem(props.type + "-loan-refresh");
    if (refreshMark == "true") {
      crudApi?.refresh();
      localStorage.setItem(props.type + "-loan-refresh", "false");
      console.log("tab到当前页面刷新列表");
    }
  }

  const initRefreshInterval = (rsApi: CrudApi) => {
    if (
      role != "agent" &&
      (props.type == "my" || props.type == "team" || props.type == "notAssign")
    ) {
      //先销毁
      clearInterval(refreshLeadInterval.current);
      //开启定时器
      refreshLeadInterval.current = setInterval(() => refreshLead(), 15000);
      let refreshLead = async () => {
        let refreshMark = localStorage.getItem(props.type + "-loan-refresh");
        if (refreshMark == "true") {
          rsApi?.refresh();
          localStorage.setItem(props.type + "-loan-refresh", "false");
          console.log(
            props.router + "定时器：刷新客户列表：",
            new Date().toLocaleTimeString()
          );
        }
      };
    }
  };

  const handleOk = () => {
    setLoan(undefined);
    crudApi?.refresh();
  };

  const handleAuditing = (loanId: number) => {
    apiClient.auditingLoan(loanId).then((resp) => {
      if (resp.code == "ok") {
        crudApi?.refresh();
      }
    });
  };

  const handleAssignButtonClick = (a: any, rows: any) => {
    if (!rows || rows.length == 0) {
      Toast.info("请选择客户");
      return;
    }
    setselectedLoans(rows);
    setIsAdd(true);
    setShowAssignModal(true);
  };

  const handleAssignAgentButtonClick = (a: any, rows: any) => {
    if (!rows || rows.length == 0) {
      Toast.info("请选择客户");
      return;
    }
    setselectedLoans(rows);
    setIsAdd(false);
    setShowAssignModal(true);
  };
  const handleRemoveAssignButtonClick = (a: any, rows: any) => {
    if (!rows || rows.length == 0) {
      Toast.info("请选择客户");
      return;
    }
    let ids = rows.map((i: any) => i.id);
    Modal.confirm({
      title: "是否确认从我的按揭里移除?",
      content: "",
      onOk: async () => {
        try {
          await apiClient.request(
            "/leadLoans/removeAssign",
            "POST",
            undefined,
            {
              leadIds: ids,
            }
          );
          //全部按揭需要刷新
          localStorage.setItem("notAssign-loan-refresh", "true");
          //  publish 发布消息 消息名为：name 内容为：
          pubsub.publish("refreshMenuCount", "");

          Toast.info("已从我的按揭里移除");
          setselectedLoans([]);
          crudApi?.refresh();
        } catch (e) {}
      },
    });
  };

  const handleAssignSaleButtonClick = (a: any, rows: any) => {
    if (!rows || rows.length == 0) {
      Toast.info("请选择客户");
      return;
    }
    //判断rows 是否包含已分配
    let hasUnAssign = rows.some((i: any) => i.saleId != null);
    if (hasUnAssign) {
      Toast.info("选择的客户包含了已分配有销售的，只能选择未分配的客户");
      return;
    }
    setSelectedLeads(rows);
    setShowAssignSaleModal(true);
    let strIds = localStorage.getItem("assignToIds");
    if (strIds) {
      apiClient
        .request("/users/removeLeaveUserId", "GET", {
          ids: JSON.parse(strIds),
        })
        .then((resp: any) => {
          setSelectedMembers(resp.data);
        });
    }
  };

  const actions: CrudAction[] = [];
  const assignAction: CrudAction = {
    name: "添加",
    action: handleAssignButtonClick,
  };
  const assignAgentAction: CrudAction = {
    name: "分配按揭",
    action: handleAssignAgentButtonClick,
  };
  const removeAssignAction: CrudAction = {
    name: "移除",
    action: handleRemoveAssignButtonClick,
  };
  const assignSaleAction: CrudAction = {
    name: "分配销售",
    action: handleAssignSaleButtonClick,
  };
  if (props.type == "all") {
    cols = cols.concat(assignedCol);
    if (role == "agent_manager" || role == "root" || role == "op_manager") {
      actions.push(assignSaleAction);
      actions.push(assignAgentAction);
    }
  }
  if (props.type == "notAssign") {
    actions.push(assignAction);
  }
  if (props.type == "my") {
    actions.push(removeAssignAction);
    cols = cols.concat(assignedCol);
  }
  if (props.type == "team") {
    actions.push(assignAgentAction);
    actions.push(removeAssignAction);
    cols = cols.concat(assignedCol);
  }

  const handleAssignClick = async () => {
    setAssignSaving(true);
    try {
      await assignFormApi!.validate();
      await apiClient.request(
        "/leadLoans/claim",
        "POST",
        undefined,
        assignFormApi!.getValues()
      );

      //我的按揭需要刷新
      localStorage.setItem("my-loan-refresh", "true");
      //  publish 发布消息 消息名为：name 内容为：
      pubsub.publish("refreshMenuCount", "");

      setselectedLoans([]);
      crudApi?.refresh();

      setAssignSaving(false);
      setShowAssignModal(false);

      //  publish 发布消息 消息名为：name 内容为：
      //pubsub.publish("refreshMenuCount", "");
    } catch (e) {
      setAssignSaving(false);
    }
  };

  const handleAssignSaleClick = async () => {
    setAssignSaving(true);
    try {
      await assignSaleFormApi!.validate();
      await apiClient.request(
        "/leads/assign",
        "POST",
        undefined,
        assignSaleFormApi!.getValues()
      );
      //保存上次分配用户
      let assignToIds = assignSaleFormApi!.getValue("assignToIds");
      localStorage.setItem("assigToIds", JSON.stringify(assignToIds));

      setSelectedLeads([]);
      crudApi?.refresh();
      //我的客户需要刷新
      localStorage.setItem("my-refresh", "true");
      localStorage.setItem("all-refresh", "true");
      setAssignSaving(false);
      setShowAssignSaleModal(false);

      //  publish 发布消息 消息名为：name 内容为：
      pubsub.publish("refreshMenuCount", "");
    } catch (e) {
      setAssignSaving(false);
    }
  };

  //打开详情
  const detailAction = (a: Lead, all: Lead[] | undefined) => {
    let ids: any = [];
    if (all) {
      ids = all.map((i) => i.id);
      setLeadIds(ids);
    }
    const w = window.open("about:blank");
    if (w != null) {
      const data = {
        id: a.id,
        ids: [],
        visitMode: false,
        viewMode: true,
        queryParams: crudApi?.getQueryParams(),
      };
      w.location.href =
        "/#/loanlead?data=" + encodeURIComponent(JSON.stringify(data));
    }
  };

  //打开详情
  const doContactAction = (a: Lead, all: Lead[] | undefined) => {
    let ids: any = [];
    if (all) {
      ids = all.map((i) => i.id);
      setLeadIds(ids);
    }
    const w = window.open("about:blank");
    if (w != null) {
      const data = {
        id: a.id,
        ids: [],
        visitMode: false,
        viewMode: false,
        queryParams: crudApi?.getQueryParams(),
      };
      w.location.href =
        "/#/loanlead?data=" + encodeURIComponent(JSON.stringify(data));
    }
  };

  const rowActions: CrudAction[] = [];
  const contactAction: CrudAction = {
    name: "跟进",
    action: doContactAction,
  };

  // const loanAction: CrudAction = {
  //   name: "回款",
  //   action: (loan) => {
  //   setLoan(loan);
  //  }
  // };

  const confirmAction: CrudAction = {
    name: "确认",
    action: () => {
      handleAuditing(loan!.id);
    },
  };

  const leadDetailAction: CrudAction = {
    name: "详情",
    action: detailAction,
  };

  if (props.type == "all" || props.type == "notAssign") {
    rowActions.push(leadDetailAction);
  } else {
    rowActions.push(contactAction);
    //rowActions.push(loanAction);
  }

  const renderLabel = (label: any, item: any) => (
    <div
      style={{
        padding: "6px 8px",
        lineHeight: 1.0,
      }}
    >
      <div
        style={{
          fontWeight: 500,
          color: "var(--semi-color-text-0)",
          fontSize: 14,
        }}
      >
        {label}
        <span
          style={{
            fontSize: 12,
            color: "var(--semi-color-text-2)",
            marginLeft: 10,
          }}
        >
          {item.labelSubText}
        </span>
      </div>
    </div>
  );

  const renderCustomOption = (item) => {
    const optionStyle = {
      display: "flex",
      paddingTop: 10,
      paddingBottom: 10,
    };
    return (
      <Select.Option
        value={item.value}
        style={optionStyle}
        showTick={true}
        key={item.value}
      >
          {item.label} - {item.labelSubText}
         
      </Select.Option>
    );
  };

  return (
    <div>
      <Modal
        icon={
          <IconModalStroked size={"extra-large"} style={{ color: "blue" }} />
        }
        style={{ width: 600, height: 400 }}
        title={isAdd?"添加按揭客户":"分配按揭客户"}
        visible={showAssignModal}
        okText= {isAdd?"添加":"分配"}
        confirmLoading={assignSaving}
        onOk={handleAssignClick}
        onCancel={() => setShowAssignModal(false)}
      >
        <Form getFormApi={(formApi) => setAssignFormApi(formApi)}>
          <Form.Select
            rules={[{ required: true, message: "请选择" }]}
            disabled
            initValue={selectedLoansRef.current.map((l) => l.id)}
            style={{ width: "100%" }}
            multiple
            field="leadIds"
            label="按揭客户"
          >
            {selectedLoansRef.current.map((l) => (
              <Form.Select.Option key={l.id + ""} value={l.id}>
                {l.name}
              </Form.Select.Option>
            ))}
          </Form.Select>
          {(isAdd && <Form.Input
            disabled
            field="userRealName"
            initValue={userRealName}
            label="按揭专员"
          />)}
          {(!isAdd && <Form.Select
            rules={[{ required: true, message: "请选择" }]}
            style={{ width: "100%" }}
            field="userId"
            label="按揭专员"
            filter
          >
            {selectedAgents.map((l) => renderCustomOption(l))}
          </Form.Select>)}
        </Form>
      </Modal>
      <Modal
        icon={
          <IconModalStroked size={"extra-large"} style={{ color: "blue" }} />
        }
        style={{ width: 1200, height: 650 }}
        title="分配客户"
        visible={showAssignSaleModal}
        okText="分配"
        confirmLoading={assignSaving}
        onOk={handleAssignSaleClick}
        onCancel={() => setShowAssignSaleModal(false)}
      >
        <Form getFormApi={(formApi) => setAssignSaleFormApi(formApi)}>
          <Form.TreeSelect
            placeholder="请选择分配给谁"
            rules={[{ required: true, message: "请填写" }]}
            style={{ width: "100%" }}
            field="assignToIds"
            label="销售"
            //defaultExpandAll
            checkRelation="unRelated"
            leafOnly
            multiple
            treeData={teamMembersTree}
            initValue={selectedMembersRef.current}
            filterTreeNode
            showFilteredOnly={true}
            searchPlaceholder="请输入关键字开始搜索"
            renderLabel={renderLabel}
            autoAdjustOverflow={false}
            virtualize={{
              itemSize: 28,
              height: 400,
            }}
          ></Form.TreeSelect>
          <Form.Select
            rules={[{ required: true, message: "请填写" }]}
            disabled
            initValue={selectedLeads.map((l) => l.id)}
            style={{ width: "100%" }}
            multiple
            field="leadIds"
            label="客户"
          >
            {selectedLeads.map((l) => (
              <Form.Select.Option key={l.id + ""} value={l.id}>
                {l.name}
              </Form.Select.Option>
            ))}
          </Form.Select>
        </Form>
      </Modal>
      <Crud<Lead>
        getCrudApi={(crudApiT) => {
          setCrudApi(crudApiT);
          initRefreshInterval(crudApiT);
        }}
        actions={actions}
        select={true}
        canUpdate={false}
        canCreate={false}
        name={props.name}
        entityKey="leadLoans"
        params={{
          type: props.type,
        }}
        getRowActions={(lead) => {
          if (username == "root" && lead.auditingStatus == "NOT_AUDITING") {
            rowActions.push(confirmAction);
          }
          return rowActions;
        }}
        pageSize={50}
        cols={cols}
      />
    </div>
  );
}
